import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app.store';
import type {
  OnboardingState,
  OnboardStatus,
  OrgInfo,
  PlanInfo,
} from './onboarding.type';

const initialState: OnboardingState = {
  status: 'not-registered',
  organizationInfo: null,
  planInfo: null,
};

const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    // Update registration status
    updateStatus: (state, { payload }: PayloadAction<OnboardStatus>) => {
      state.status = payload;
    },

    // Set organization info (simplified)
    setOrganizationInfo: (state, { payload }: PayloadAction<OrgInfo>) => {
      state.organizationInfo = payload;
    },

    // Set plan info (simplified)
    setPlanInfo: (state, { payload }: PayloadAction<PlanInfo>) => {
      state.planInfo = payload;
    },

    // Reset onboarding state
    resetOnboardingState: (state) => {
      state.status = 'not-registered';
      state.organizationInfo = null;
      state.planInfo = null;
    },
  },
});

export const {
  updateStatus,
  setOrganizationInfo,
  setPlanInfo,
  resetOnboardingState,
} = onboardingSlice.actions;

export const onboardingReducer = onboardingSlice.reducer;

/* ------ Selectors ------ */
export const selectOrgInfo = (state: RootState) => state.onboarding.organizationInfo;
export const selectPlanInfo = (state: RootState) => state.onboarding.planInfo;
